module.exports = __webpack_public_path__ + "img/item-grade.dfeeb35a.png";